require('./video.css');
let Core = require('../modules/core/');
let Poster = require('../modules/poster/');
let PlayButton = require('../modules/playButton/');
let Control = require('../modules/liveControl/');
let Title = require('../modules/title/');
let ErrorBox = require('../modules/error/');
let statistics = require('../modules/statistics/');
let Cutdown = require('../modules/cutdown/');
let Ready = require('../modules/ready/');
let List = require('../modules/list/');
let Network = require('../modules/network/');

let Events = require('f.core.event');

let createMsg = function(options) {
    return {
        videoid: options.channelId,
        categoryId: options.categoryId || '0017',
        columnName: options.columnName || '',
        provider: options.provider || ''
    };
};
let Video = function(options) {
    this.options = options;
    this.options.playermsg = createMsg(options.list[0]);
    this.isSpread = true;
    this.init();
};

Video.prototype.init = function() {
    this.initParams();
    this.initLayout();
    this.initCompontent();
    this.initEvent();
};

Video.prototype.initParams = function() {};

Video.prototype.initLayout = function() {
    this.el = document.createElement('div');
    this.el.classList.add('c-video');
};

Video.prototype.initCompontent = function() {
    this.core = new Core({
        src: this.options.src,
        poster: this.options.poster,
        inline: true,
        autoplay: this.options.autoplay
    });

    pageVideoList.push(this.core);

    this.playButton = new PlayButton();
    this.playButton.changeState('pause');
    this.control = new Control(this.options);
    this.poster = new Poster(this.options.poster);
    this.title = new Title(this.options.title, this.options.channelName, this.options.channelIcon);
    this.error = new ErrorBox(this.options.errorTitle);
    this.cutdown = new Cutdown(this.options.start_time);
    this.ready = new Ready();
    this.list = new List(this.options.list);
    this.network = new Network();

    this.core.renderTo(this.el);
    this.playButton.renderTo(this.el);
    this.control.renderTo(this.el);
    this.poster.renderTo(this.el);
    this.title.renderTo(this.el);
    this.error.renderTo(this.el);
    this.cutdown.renderTo(this.el);
    this.ready.renderTo(this.el);
    this.list.renderTo(this.el);
    this.network.renderTo(this.el);
    // this.ready.show();
    // this.playButton.hide();
    // this.cutdown.show();
    // this.cutdown.begin();
};

Video.prototype.renderTo = function(parentNode) {
    parentNode.appendChild(this.el);
};

/**
 * 自定义事件列表
 * begin 每个视频开始播放时 一般用来发cv统计
 * ended 视频播放结束时
 * pause 视频暂停
 * play 视频播放
 * switch 视频切换
 * init 初始化视频 主要用于发vv统计
 * input 横屏时点击输入弹幕区域
 */
Video.prototype.initEvent = function() {
    let core = this.core;
    let control = this.control;
    let playButton = this.playButton;
    let poster = this.poster;
    let title = this.title;
    let error = this.error;
    let cutdown = this.cutdown;
    let ready = this.ready;
    let list = this.list;
    let network = this.network;
    let self = this;
    let options = this.options;

    let notBegin = true;

    // 视频首次开始播放
    core.on('begin', function() {
        statistics(options.playermsg, 'cv');
        // title.hide();
        control.show();
        poster.hide();
        ready.hide();
        playButton.changeState('play');
        self.trigger('begin');
    });

    core.on('playing', function() {
        notBegin = false;
        self.trigger('hideCount');
    });

    // 视频内部切换
    core.on('switch', function(oldSrc, newSrc) {
        self.trigger('switch', oldSrc, newSrc);
    });

    core.on('loadedmetadata', function() {
        statistics(options.playermsg, 'vv');
        self.trigger('init');
    });

    // 视频播放
    core.on('play', function() {
        // let current = Core.current();
        // console.log(current);
        // if (current && core !== current) {
        //     current.pause();
        // }
        for (let i = 0; i < pageVideoList.length; i++) {
            const otherCore = pageVideoList[i];
            if (otherCore !== core) {
                otherCore.pause();
            }
        }
        // playButton.changeState('play');
        // control.changePlayState('play');
    });

    // core.on('timeupdate', function () {
    // //   if (core.getCurrentTime() > 0.1){
    // //     poster.hide();
    // //     error.hide();
    // //   }

    // });

    // 视频暂停
    // core.on('pause', function () {
    //
    // });

    // 视频播放完成
    // core.on('ended', function () {
    //   playButton.changeState('replay');
    //   self.trigger('ended');
    // });

    let errrTimer = null;
    // core.on('error', function (e) {
    //   if (notBegin) {
    //     ready.show();
    //   } else {
    //     error.show();
    //   }
    //   clearTimeout(errrTimer);
    //   errrTimer = setTimeout(function () {
    //     console.log('try replay');
    //     core.load();
    //     core.play();
    //   }, 5000);
    //   self.trigger('error', e);
    // });
    core.on('pause', () => {
        // 如果视频是直播，触发广告暂停事件
        if (self.isSpread) {
            self.trigger('pauseAd');
        }
    });

    core.on('waitingStatus', () => {
        playButton.changeState('waiting');
    });

    core.on('endStatus', () => {
        playButton.changeState('replay');
        self.trigger('ended');
    });

    core.on('errorStatus', (e) => {
        // debugger
        if (this.cutdown.time >= Date.now()) {
            ready.show();
        } else {
            error.show();
        }
        // clearTimeout(errrTimer);
        // errrTimer = setTimeout(function () {
        //     console.log('try replay');
        //     core.load();
        //     core.play();
        // }, 5000);
        self.trigger('error', e);
    });

    core.on('playingStatus', () => {
        // 由于安卓端兼容性原因，将控层的样式修改放在video的timeupdate事件中
        playButton.changeState('play');
        control.changePlayState('play');
        poster.hide();
        // playButton.show();
        error.hide();
    });

    core.on('timeupdate', function() {
        // self.trigger('playing');
        if (core.getCurrentTime() > 0.1) {
            playButton.changeState('play');
            control.changePlayState('play');
            poster.hide();
        }
    });

    core.on('pauseStatus', () => {
        playButton.changeState('pause');
        playButton.show();
        control.changePlayState('pause');
        console.log('视频暂停+3');
        self.trigger('pause');
    });

    // 点击播放器前面的控制蒙层
    playButton.on('click', function(e) {
        if (self.isSpread) {
            // 展开
            if (core.getEnded() || core.getPaused()) {
                core.play();
            } else {
                control.toggle();
                return;
            }
        } else {
            // 折叠
            self.trigger('shrinkOpen');
            if (core.getEnded() || core.getPaused()) {
                core.play();
                return;
            } else {
                core.pause();
                return;
            }
        }

        if (core.getNetworkState() == 3) {
            control.toggle();
        }
    });

    title.on('exit', function() {
        self.trigger('exit');
        console.log('exit');
    });

    // 控制条点击播放按钮
    control.on('play', function() {
        network.hide();
        if (core.getPaused()) {
            core.play();
        } else {
            console.log('视频暂停+4');
            core.pause();
            // 暂停添加居中广告
            if (self.isSpread) {
                self.trigger('pauseAd');
            }
        }
    });

    control.on('show', function() {
        title.show();
        list.show();
        self.trigger('controlShow');
    });

    control.on('hide', function() {
        title.hide();
        list.hide();
        self.trigger('controlHide');
    });

    control.on('zoom', function(state) {
        self.trigger('zoom', state);
    });

    cutdown.on('end', function() {
        self.trigger('cutdownEnd');
        // core.play();
    });

    // control.on('inputClick', function () {
    //   self.trigger('inputClick');
    // });

    // control.on('barrageClick', function (state) {
    //   self.trigger('barrageClick', state);
    // });

    list.on(
        'switch',
        function(url, index) {
            let videoOption = this.options.list[index];
            core.src(videoOption.m3u8);
            // core.setPoster(videoOption.poster);
            core.play();
            this.options.playermsg = createMsg(videoOption);
        }.bind(this)
    );

    network.on('network_retry', function() {
        window.location.reload();
    });

    network.on('network_continue', function() {
        core.play();
        network.hide();
    });

    network.on('network_toggle', function() {
        control.toggle();
    });

    error.on('error_toggle', function() {
        control.toggle();
    });
};

Video.prototype.afterAdPause = function() {
    this.playButton.trigger('click');
};

Video.prototype.play = function() {
    this.trigger('playAd'); // 视频播放时隐藏广告
    // this.cutdown.hide();
    this.core.play();
};

Video.prototype.load = function() {
    this.core.load();
};

Video.prototype.pause = function() {
    console.log('视频暂停+5');
    this.core.pause();
};

Video.prototype.getCurrentTime = function() {
    return this.core.getCurrentTime();
};

Video.prototype.stop = function() {
    console.log('视频暂停+6');
    this.core.pause();
    this.control.setTime(0);
};

Video.prototype.next = function(src) {
    this.core.src(src);
    this.control.reset();
    this.playButton.changeState('pause');
};

Video.prototype.destory = function() {
    this.off();
    this.title.destory();
    this.control.destory();
    this.poster.destory();
    this.playButton.destory();
    this.error.destory();
    this.core.destory();
};

Video.prototype.hide = function() {
    if (!this.isHide) {
        $(this.el).hide();
        this.isHide = true;
    }
};

Video.prototype.show = function() {
    if (this.isHide) {
        $(this.el).show();
        this.isHide = false;
    }
};

Video.prototype.spread = function() {
    this.isSpread = true;
    // this.play();
};

Video.prototype.fold = function() {
    this.isSpread = false;
    // this.pause();
};

Events.mixTo(Video);
module.exports = Video;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/lib/liveVideo.js